import http from '../../utils/fetch';

export default {
    baseurl: '/api/swyl/v1/demo/bscPromotionActivities',

    // 根据活动id查询活动详情
    getPromotionById(activityId) {
        return http({
            url: '/api/swyl/v1/demo/bscPromotionActivities/selectActivityById',
            method: 'post',
            params: {
                activityId: activityId
            }
        });
    },
    // 获取活动列表
    getPromotionList(query) {
        return http({
            url: '/api/swyl/v1/demo/bscPromotionActivities/selectList',
            method: 'post',
            params: query
        });
    },
}